module.exports = __webpack_public_path__ + "static/media/management.03dc2708.png";